<script>
  import SpotlightModal from "../../traveller/modals/Spotlight.svelte";
  import PureFeaturedBusinessCardSwiper from "./PureFeaturedBusinessCardSwiper.svelte";

  export let businesses = [];

  let activeModalBusiness;
  let open = false;

  const click = (e) => {
    activeModalBusiness = e.detail.business;
    toggle();
  };

  const toggle = () => (open = !open);
</script>

<PureFeaturedBusinessCardSwiper on:click={click} {businesses} />
<SpotlightModal business={activeModalBusiness} {open} {toggle} />
